import { Sparkles } from 'lucide-react';

/**
 * FoundingBanner — the launch-window pricing callout. Pure: renders nothing
 * unless given an active offer (so it's safe to drop anywhere; outside the
 * window it simply disappears). Money correctness is enforced server-side at
 * checkout regardless of what this shows.
 */
export default function FoundingBanner({ offer, className = '' }) {
  if (!offer || !offer.active) return null;
  const prices = offer.founding_prices || {};
  const ends = offer.ends_at ? new Date(offer.ends_at) : null;
  const endsLabel = ends && !isNaN(ends)
    ? ends.toLocaleDateString(undefined, { month: 'long', day: 'numeric' })
    : null;

  return (
    <div className={`rounded-lg border border-amber-500/40 bg-amber-500/10 px-4 py-3 ${className}`}>
      <div className="flex items-center gap-2 mb-1">
        <Sparkles size={15} className="text-amber-400" />
        <span className="text-sm font-semibold text-amber-200">Founding-member pricing</span>
      </div>
      <p className="text-xs text-amber-100/80">
        Lock the original rate for life
        {prices.pro != null && prices.entrepreneur != null
          ? `: Pro $${prices.pro}/mo, Entrepreneur $${prices.entrepreneur}/mo`
          : ''}.
        {endsLabel ? ` Offer ends ${endsLabel}.` : ''} It never goes up while you stay subscribed.
      </p>
    </div>
  );
}
